<template>
  <div class="debounced-places-autocomplete">
    <input
      ref="input"
      type="text"
      :placeholder="placeholder"
      data-cy="address_autocomplete_input"
      v-model="searchText"
      @input="onInput"
      class="form-control"
      style="border-radius: 10px !important;"
    />
    <ul v-if="predictions.length && showPredictions" class="predictions">
      <li
        v-for="p in predictions"
        :key="p.place_id"
        @click="selectPrediction(p)"
      >
        {{ p.description }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "DebouncedPlacesAutocomplete",
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "Start typing your address here",
    },
    debounceMs: {
      type: Number,
      default: 300,
    },
    countryRestrictions: {
      type: Array,
      default: () => ["uk"],
    },
  },
  data() {
    return {
      searchText: this.value || "",
      predictions: [],
      showPredictions: false,
      debounceTimer: null,
      placesService: null,
      detailsService: null,
      sessionToken: null,
    };
  },
  watch: {
    value(val) {
      if (val !== this.searchText) this.searchText = val || "";
    },
  },
  mounted() {
    if (this.$gmapApiPromiseLazy) {
      this.$gmapApiPromiseLazy().then(() => {
        // eslint-disable-next-line no-undef
        this.placesService = new google.maps.places.AutocompleteService();
        // eslint-disable-next-line no-undef
        this.detailsService = new google.maps.places.PlacesService(document.createElement("div"));
        // eslint-disable-next-line no-undef
        this.sessionToken = new google.maps.places.AutocompleteSessionToken();
      });
    }
  },
  methods: {
    onInput() {
      this.$emit("input", this.searchText);
      this.showPredictions = true;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(this.fetchPredictions, this.debounceMs);
    },
    fetchPredictions() {
      const q = this.searchText && this.searchText.trim();
      if (!q || q.length < 3 || !this.placesService) {
        this.predictions = [];
        return;
      }
      const request = {
        input: q,
        componentRestrictions: this.countryRestrictions.length
          ? { country: this.countryRestrictions }
          : undefined,
        sessionToken: this.sessionToken,
      };
      this.placesService.getPlacePredictions(request, (preds, status) => {
        // eslint-disable-next-line no-undef
        if (status !== google.maps.places.PlacesServiceStatus.OK || !preds) {
          this.predictions = [];
          return;
        }
        this.predictions = preds;
      });
    },
    selectPrediction(pred) {
      if (!this.detailsService) return;
      const detailsReq = {
        placeId: pred.place_id,
        fields: ["formatted_address", "geometry", "address_components"],
        sessionToken: this.sessionToken,
      };
      this.detailsService.getDetails(detailsReq, (place, status) => {
        // eslint-disable-next-line no-undef
        if (status !== google.maps.places.PlacesServiceStatus.OK || !place?.geometry) return;
        this.showPredictions = false;
        this.predictions = [];
        this.searchText = pred.description;
        this.$emit("place_changed", place);
        this.$emit("input", this.searchText);
        // eslint-disable-next-line no-undef
        this.sessionToken = new google.maps.places.AutocompleteSessionToken();
      });
    },
  },
};
</script>
<style scoped>
.debounced-places-autocomplete {
  position: relative;
  padding: 0 0px 0 0px !important;
  height: auto !important;
}
.predictions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 6px 0 0;
  padding: 0;
  list-style: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  max-height: 260px;
  overflow: auto;
  z-index: 9999;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}
.predictions > li {
  padding: 8px 10px;
  cursor: pointer;
}
.predictions > li:hover {
  background: #f5f5f5;
}
</style>

